<template>
  <div :class="mainClassList">
    <div
      v-show="mobileMenuOpen"
      class="mobile-menu-overlay"
      @click="closeMobileMenu"
    ></div>
    <!--left menu-->
    <LeftMenu @selectMenu="selectMenuFunc"></LeftMenu>

    <!--right content-->
    <RightContent></RightContent>
  </div>
</template>

<script>
import LeftMenu from '@/views/layout/LeftMenu.vue';
import RightContent from '@/views/layout/RightContent.vue';
import store from '@/store/';
import bus from '@/utils/eventBus.js';

export default {
  components: {
    /*左菜单组件*/
    LeftMenu,
    /*右边内容容器*/
    RightContent
  },
  data() {
    return {
      /*移动端菜单是否展开*/
      mobileMenuOpen: false,
      /*是否有子菜单*/
      hasChild: null,
      /*系统基本数据*/
      baseInfo: {
        shop_name: '',
        logoFilePath: '',
        user: {},
        version: ''
      }
    };
  },
  computed: {
    mainClassList() {
      return [
        'main',
        this.hasChild == null ? 'right-big' : '',
        this.mobileMenuOpen ? 'mobile-menu-open' : ''
      ];
    }
  },
  provide: function() {
    return {
      baseInfo: this.baseInfo
    };
  },
  created() {
    this.getBaseInfo();
    bus.$on('toggleMobileMenu', this.toggleMobileMenu);
    bus.$on('closeMobileMenu', this.closeMobileMenu);
  },
  beforeDestroy() {
    bus.$off('toggleMobileMenu', this.toggleMobileMenu);
    bus.$off('closeMobileMenu', this.closeMobileMenu);
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },

    closeMobileMenu() {
      this.mobileMenuOpen = false;
    },

    /*左边子组件传来的参数*/
    selectMenuFunc(param) {
      this.hasChild = param;
    },

    async getBaseInfo() {
      let res = await store.dispatch('common/getBaseInfo');
      this.baseInfo.shop_name = res.shop_name;
      this.baseInfo.logoFilePath = res.logoFilePath;
      this.baseInfo.version = res.version;
      this.baseInfo.user = res.user;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/layout/main.vue